import React, { useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { postData } from "utils/TransactionUtil";
import { AuthContext } from "contexts/AuthContext";
import Icon from "components/Icon/Icon";

const customStyles = {
    control: (base, state) => ({
        ...base,
        font: '400 15px/1.5 Pretendard',
        minHeight: 40,
        height: 40,
        minWidth: '100px',
        borderRadius: "2px",
        padding: "0 3px 0 8px",
        border: state.isFocused ? "1px solid #212121" : "1px solid #E0E0E0",
        boxShadow: "none",
        cursor: state.isDisabled ? "not-allowed" : "pointer", // 🚫 비활성화 시 금지 표시
        backgroundColor: state.isDisabled ? "#F5F5F5" : "white", // 🔹 비활성화 시 배경색 변경
        "&:hover": state.isDisabled ? {} : { border: "1px solid #212121" },
    }),
    placeholder: (base) => ({
        ...base,
        color: "#BDBDBD",
    }),
    singleValue: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        font: '400 16px/1.5 Pretendard',
        color: "#424242",
    }),
    option: (base, state) => ({
        ...base,
        font: '400 15px/1.5 Pretendard',
        backgroundColor: state.isSelected ? "#F4F4F4" : "transparent",
        color: state.isSelected ? "#555555" : "#333",
        cursor: state.isDisabled ? "not-allowed" : "pointer", // 🚫 옵션도 비활성화 가능
        "&:hover": state.isDisabled ? {} : { backgroundColor: "#FAFAFA", color: "#555555" },
    }),
    input: (provided, state) => ({
        ...provided,
        caretColor: state.isDisabled ? "transparent" : "auto",
    }),
};

const CustomDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
        <button style={{ marginRight: "4px", display: "flex" }}>
            <Icon id="downAngleBrackets_01" width="16" height="16" />
        </button>
    </components.DropdownIndicator>
);

const SelectBox = ({
                    comnGrpCd = "",
                    value,
                    onChange,
                    valueKey = "comnDtlsCd",
                    labelKey = "detlCdNm",
                    options = [],
                    placeholder = "",
                    width = "100%",
                    isAllExpr = true,  //전체 표현 여부
                    isDisabled = false,
                   }) => {
    
    const [optVal, setOptVal] = useState([]);
    const auth = useContext(AuthContext);

    useEffect(() => {
        if (comnGrpCd) {
            if (auth.isLoggedIn) {
                actionGetCode();
            }else{
                console.log("로그인되지 않아 사용할 수 없습니다.");
                return;
            }
        }
    }, [auth.isLoggedIn]);


  useEffect(() => {
    if (options.length > 0) {
      let updOpt = reNmCols(options, { [valueKey]: "value", [labelKey]: "label" });

      if (!updOpt.some(opt => opt.value === null) && isAllExpr) {
        updOpt = [{ value: null, label: "" }, ...updOpt];
      }

      setOptVal(updOpt);

      // 🔥 여기 조건이 렌더마다 바뀔 가능성이 있음
      if (!updOpt.some(opt => opt.value === value)) {
        // 🔒 value가 undefined일 때만 호출되도록 제한 (또는 처음 한 번만)
        if (value === undefined || value === null) {
          onChange(updOpt[0]?.value || null);
        }
      }

    } else if (!comnGrpCd) {
      setOptVal([]);
      onChange(null);
    }
  }, [options, auth.isLoggedIn]);


    const reNmCols = (array, mapping) =>
        array.map((item) => {
            const newItem = {};
            for (const key in item) {
                newItem[mapping[key] || key] = item[key];
            }
            return newItem;
        });

    const actionGetCode = async () => {
        await postData("/getComCd", { comnGrpCd }).then((data) => {

            let updOpt = reNmCols(data, { [valueKey]: "value", [labelKey]: "label" });
            if (!updOpt.some(opt => opt.value === null) && isAllExpr) {
                updOpt = [{ value: null, label: "전체" }, ...updOpt];
            }
            setOptVal(updOpt);

            if (!updOpt.some(opt => opt.value === value)) {
                 onChange(updOpt[0]?.value || null);
            }
        });
    };

    const handleChange = (e) => {
        onChange(e ? e.value : null);
    };

    return (
        <div style={{ width }}>
            <Select
                value={optVal.find(opt => opt.value === value) || null}
                styles={customStyles}
                options={optVal}
                onChange={isDisabled ? () => {} : handleChange} // 🚫 비활성화 상태에서는 변경 막기
                placeholder={placeholder}
                components={{
                    DropdownIndicator: CustomDropdownIndicator,
                    IndicatorSeparator: () => null,
                }}
                isDisabled={isDisabled}
            />
        </div>
    );
};

export default SelectBox;
